import { createAction } from 'redux-actions';

export const OPEN_MODAL = 'MODALS::OPEN_MODAL';
export const CLOSE_MODAL = 'MODALS::CLOSE_MODAL';

export const openModal = createAction(OPEN_MODAL);
export const closeModal = createAction(CLOSE_MODAL);
